import { render, staticRenderFns } from "./PaymentEditor.vue?vue&type=template&id=1098bfb9&"
import script from "./PaymentEditor.vue?vue&type=script&lang=js&"
export * from "./PaymentEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports